module.exports = __webpack_public_path__ + "img/emoji-thumbsdown-240x240.319adecd.png";